module.exports = {
 	"LOGOURL": APP_CONFIG.LOGOURL || "https://www.ucloud.cn",                                      // logo的链接
	// "URL009": "https://docs.ucloud.cn/agreement/README",                                     // 注册页的用户协议勾选文案 云服务声明与协议
 	"URL001":  APP_CONFIG.URL001 || "https://docs.ucloud.cn/agreement/README",      // 注册页的用户协议勾选文案 云服务声明与协议
	// "URL002":  APP_CONFIG.URL002 || "https://docs.ucloud.cn/agreement/privacypolicy",       // 注册时候的《云服务法律声明及隐私条款》链接
 	"URL003":  APP_CONFIG.URL003 || "https://www.ucloud.cn/site/service.html",                     // 顶部【帮助】链接
	"URL004":  APP_CONFIG.URL004 || "https://www.ucloud.cn",                                       // 顶部【回到首页】链接
	"URL006":  APP_CONFIG.URL006 || APP_CONFIG.URL004 || "https://www.ucloud.cn",                                       // 顶部【回到英文首页】链接
	// "URL005":  APP_CONFIG.URL005 || "https://docs.ucloud.cn/policy/agreement/security",  //注册时候的《UCloud云平台安全规则》链接 
	"URL007":  APP_CONFIG.URL007 || "https://static.ucloud.cn/700a0d6f5bb64a3faf8173b749b77df0.pdf",  //注册时候的《云服务法律声明及隐私条款》链接，海外项目专用
	"URL008":  APP_CONFIG.URL008 || "https://static.ucloud.cn/700a0d6f5bb64a3faf8173b749b77df0.pdf",  //注册时候的《云服务法律声明及隐私条款》链接，海外项目专用
}



// WEBPACK FOOTER //
// ./src/config/urls.js